import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export default function ThemeSelector({ label, themes, value, onChange }) {
  return (
    <div>
      <Text strong>{label}</Text>
      <div className="theme-grid" style={{ marginTop: 12 }}>
        {themes.map((t) => (
          <div key={t.key} className={`theme-card ${value === t.key ? 'active' : ''}`} onClick={() => onChange(t.key)}>
            <Text>{t.label}</Text>
          </div>
        ))}
      </div>
    </div>
  );
}


